import { defineTextStyles } from '@chakra-ui/react/styled-system';

const basicTextStyles = {
  'mono/code-2': {
    value: {
      fontFamily: 'mono',
      fontSize: '0.75rem',
      lineHeight: '1rem',
      letterSpacing: '-0.009375rem',
      fontWeight: '400',
    },
  },
  'mono/code-3': {
    value: {
      fontFamily: 'mono',
      fontSize: '0.875rem',
      lineHeight: '1.25rem',
      letterSpacing: '-0.009375rem',
      fontWeight: '400',
    },
  },
  'sans/size-1/normal': {
    value: {
      lineHeight: '1rem',
      fontSize: '0.75rem',
      letterSpacing: '0.009375rem',
      fontWeight: '400',
    },
  },
  'sans/size-1/normal-underline': {
    value: {
      lineHeight: '1rem',
      fontSize: '0.75rem',
      letterSpacing: '0.009375rem',
      textDecoration: 'underline',
      fontWeight: '400',
    },
  },
  'sans/size-1/semibold': {
    value: {
      fontWeight: '600',
      lineHeight: '1rem',
      fontSize: '0.75rem',
      letterSpacing: '0.009375rem',
    },
  },
  'sans/size-1/semibold-underline': {
    value: {
      fontWeight: '600',
      lineHeight: '1rem',
      fontSize: '0.75rem',
      letterSpacing: '0.009375rem',
      textDecoration: 'underline',
    },
  },
  'sans/size-1/bold': {
    value: {
      fontWeight: '700',
      lineHeight: '1rem',
      fontSize: '0.75rem',
      letterSpacing: '0.009375rem',
    },
  },
  'sans/size-1/uppercase-bold': {
    value: {
      fontWeight: '700',
      lineHeight: '1rem',
      fontSize: '0.75rem',
      letterSpacing: '0.009375rem',
      textTransform: 'uppercase',
    },
  },
  'sans/size-2/normal': {
    value: {
      lineHeight: '1.25rem',
      fontSize: '0.875rem',
      fontWeight: '400',
    },
  },
  'sans/size-2/normal-underline': {
    value: {
      lineHeight: '1.25rem',
      fontSize: '0.875rem',
      textDecoration: 'underline',
      fontWeight: '400',
    },
  },
  'sans/size-2/semibold': {
    value: {
      fontWeight: '600',
      lineHeight: '1.25rem',
      fontSize: '0.875rem',
    },
  },
  'sans/size-2/semibold-underline': {
    value: {
      fontWeight: '600',
      lineHeight: '1.25rem',
      fontSize: '0.875rem',
      textDecoration: 'underline',
    },
  },
  'sans/size-2/bold': {
    value: {
      fontWeight: '700',
      lineHeight: '1.25rem',
      fontSize: '0.875rem',
    },
  },
  'sans/size-2/uppercase-normal': {
    value: {
      fontWeight: '400',
      lineHeight: '1.25rem',
      fontSize: '0.875rem',
      letterSpacing: '0.009375rem',
      textTransform: 'uppercase',
    },
  },
  'sans/size-2/uppercase-semibold': {
    value: {
      fontWeight: '600',
      lineHeight: '1.25rem',
      fontSize: '0.875rem',
      letterSpacing: '0.009375rem',
      textTransform: 'uppercase',
    },
  },
  'sans/size-3/normal': {
    value: {
      lineHeight: '1.5rem',
      fontSize: '1rem',
      fontWeight: '400',
    },
  },
  'sans/size-3/normal-underline': {
    value: {
      lineHeight: '1.5rem',
      fontSize: '1rem',
      textDecoration: 'underline',
      fontWeight: '400',
    },
  },
  'sans/size-3/semibold': {
    value: {
      fontWeight: '600',
      lineHeight: '1.5rem',
      fontSize: '1rem',
    },
  },
  'sans/size-3/semibold-underline': {
    value: {
      fontWeight: '600',
      lineHeight: '1.5rem',
      fontSize: '1rem',
      textDecoration: 'underline',
    },
  },
  'sans/size-3/bold': {
    value: {
      fontWeight: '700',
      lineHeight: '1.5rem',
      fontSize: '1rem',
    },
  },
  'sans/size-4/normal': {
    value: {
      lineHeight: '1.75rem',
      fontSize: '1.1875rem',
      fontWeight: '400',
    },
  },
  'sans/size-4/semibold': {
    value: {
      fontWeight: '600',
      lineHeight: '1.75rem',
      fontSize: '1.1875rem',
    },
  },
  'sans/size-4/bold': {
    value: {
      fontWeight: '700',
      lineHeight: '1.75rem',
      fontSize: '1.1875rem',
    },
  },
  'sans/size-5/normal': {
    value: {
      lineHeight: '2.25rem',
      fontSize: '1.5rem',
      fontWeight: '400',
    },
  },
  'sans/size-5/semibold': {
    value: {
      fontWeight: '600',
      lineHeight: '2.25rem',
      fontSize: '1.5rem',
    },
  },
  'sans/size-5/bold': {
    value: {
      fontWeight: '700',
      lineHeight: '2.25rem',
      fontSize: '1.5rem',
    },
  },
  'sans/size-6/normal': {
    value: {
      lineHeight: '2.5rem',
      fontSize: '1.875rem',
      fontWeight: '400',
    },
  },
  'sans/size-6/semibold': {
    value: {
      fontWeight: '600',
      lineHeight: '2.5rem',
      fontSize: '1.875rem',
    },
  },
  'sans/size-6/bold': {
    value: {
      fontWeight: '700',
      lineHeight: '2.5rem',
      fontSize: '1.875rem',
    },
  },
  'sans/size-7/semibold': {
    value: {
      fontWeight: '600',
      lineHeight: '3rem',
      fontSize: '2.25rem',
    },
  },
  'sans/size-7/bold': {
    value: {
      fontWeight: '700',
      lineHeight: '3rem',
      fontSize: '2.25rem',
    },
  },
  'sans/size-8/semibold': {
    value: {
      fontWeight: '600',
      lineHeight: '3.75rem',
      fontSize: '3rem',
    },
  },
  'sans/size-8/bold': {
    value: {
      fontWeight: '700',
      lineHeight: '3.75rem',
      fontSize: '3rem',
    },
  },
};

export const dataObject = {
  ...basicTextStyles,
  'display/lg': basicTextStyles['sans/size-8/bold'],
  'display/sm': basicTextStyles['sans/size-7/bold'],
  'heading/h1': basicTextStyles['sans/size-6/bold'],
  'heading/h2': basicTextStyles['sans/size-5/bold'],
  'heading/h3': basicTextStyles['sans/size-4/bold'],
  'heading/h4': basicTextStyles['sans/size-3/bold'],
  'heading/h5': basicTextStyles['sans/size-2/bold'],
  'heading/h6': basicTextStyles['sans/size-1/uppercase-bold'],
  'heading/mobile/h1': basicTextStyles['sans/size-5/bold'],
  'heading/mobile/h2': basicTextStyles['sans/size-4/bold'],
  'heading/mobile/h3': basicTextStyles['sans/size-3/bold'],
  'body/sm/regular': basicTextStyles['sans/size-1/normal'],
  'body/sm/semibold': basicTextStyles['sans/size-1/semibold'],
  'body/md/regular': basicTextStyles['sans/size-2/normal'],
  'body/md/semibold': basicTextStyles['sans/size-2/semibold'],
  'body/md/underline': basicTextStyles['sans/size-2/normal-underline'],
  'body/lg/regular': basicTextStyles['sans/size-3/normal'],
  'body/lg/semibold': basicTextStyles['sans/size-3/semibold'],
  'body/lg/underline': basicTextStyles['sans/size-3/normal-underline'],
  'body/xl/regular': basicTextStyles['sans/size-4/normal'],
  'body/xl/semibold': basicTextStyles['sans/size-4/semibold'],
  'body/2xl/regular': basicTextStyles['sans/size-5/normal'],
  'body/2xl/semibold': basicTextStyles['sans/size-5/semibold'],
  'body/2xl/bold': basicTextStyles['sans/size-5/bold'],
  'body/3xl/regular': basicTextStyles['sans/size-6/normal'],
  'body/3xl/semibold': basicTextStyles['sans/size-6/semibold'],
  'code/md': basicTextStyles['mono/code-2'],
  'code/lg': basicTextStyles['mono/code-3'],
  'comp/button/sm': basicTextStyles['sans/size-2/semibold'],
  'comp/button/md': basicTextStyles['sans/size-2/semibold'],
  'comp/button/lg': basicTextStyles['sans/size-3/semibold'],
  'comp/notification/title': basicTextStyles['sans/size-3/semibold'],
  'comp/notification/message': basicTextStyles['sans/size-2/normal'],
  'comp/notification/message-link': basicTextStyles['sans/size-2/normal-underline'],
  'comp/notification/button': basicTextStyles['sans/size-2/normal'],
  'comp/input/label': basicTextStyles['sans/size-2/semibold'],
  'comp/input/helperText': basicTextStyles['sans/size-1/normal'],
  'comp/link/sm': basicTextStyles['sans/size-1/normal'],
  'comp/link/sm-hover': basicTextStyles['sans/size-1/normal-underline'],
  'comp/link/md': basicTextStyles['sans/size-2/normal'],
  'comp/link/md-hover': basicTextStyles['sans/size-2/normal-underline'],
  'comp/link/lg': basicTextStyles['sans/size-3/normal'],
  'comp/link/lg-hover': basicTextStyles['sans/size-3/normal-underline'],
  'comp/data/sm': basicTextStyles['sans/size-3/normal'],
  'comp/data/md': basicTextStyles['sans/size-5/semibold'],
  'comp/data/lg': basicTextStyles['sans/size-6/semibold'],
  'comp/tabs/line': basicTextStyles['sans/size-3/bold'],
  'comp/tabs/contained': basicTextStyles['sans/size-3/bold'],
  'comp/tabs/contained-secondary': basicTextStyles['sans/size-2/normal'],
  'comp/tag/sm': basicTextStyles['sans/size-1/normal'],
  'comp/tag/md': basicTextStyles['sans/size-2/normal'],
  'comp/badge/sm': basicTextStyles['sans/size-1/uppercase-bold'],
  'comp/dialog/title': basicTextStyles['sans/size-5/bold'],
  'comp/dialog/label': basicTextStyles['sans/size-2/uppercase-semibold'],
  'comp/avatar/24': basicTextStyles['sans/size-1/bold'],
  'comp/avatar/32': basicTextStyles['sans/size-3/bold'],
  'comp/avatar/40': basicTextStyles['sans/size-4/bold'],
  'comp/avatar/48': basicTextStyles['sans/size-5/bold'],
  'comp/avatar/64': basicTextStyles['sans/size-6/bold'],
  'comp/avatar/128': basicTextStyles['sans/size-8/bold'],
};

const textStyles = defineTextStyles(dataObject);

export default textStyles;
